/**
 * 时间戳转时间字符串
 * @param {*} timestamp 时间戳
 * @param {*} type 类型
 * @param {*} empty 空值时的返回
 */
function getTime(timeStamp) {
  const nowMonth = new Date().format("yyyy/MM/dd");
  const zTime = new Date(nowMonth + " 0:0:0").getTime() / 1000;
  if (new Date().getFullYear() != ts(timeStamp, "year")) {
    return ts(timeStamp, "yearminute");
  } else if (timeStamp > zTime) {
    return "今天 " + ts(timeStamp, "minute");
  } else if (timeStamp > zTime - 86400) {
    return "昨天 " + ts(timeStamp, "minute");
  } else {
    return ts(timeStamp, "dateminute");
  }
}
function ts(timestamp, type = "datetime", empty = "--") {
  if (timestamp == 0 || !timestamp) {
    return empty;
  }
  let format;
  switch (type) {
    case "datetime":
      format = "yyyy/MM/dd hh:mm:ss";
      break;
    case "date":
      format = "yyyy/MM/dd";
      break;
    case "year":
      format = "yyyy";
      break;
    case "yearminute":
      format = "yyyy-MM-dd hh:mm";
      break;
    case "minute":
      format = "hh:mm";
      break;
    case "dateminute":
      format = "MM-dd hh:mm";
      break;
  }
  if (format) {
    return new Date(timestamp * 1000).format(format);
  }
  return empty;
}

/**
 * 时间戳转时间字符串
 * @param {*} timestamp 时间戳
 * @param {*} format 格式
 * @param {*} empty 空值时的返回
 */
function tsFormat(timestamp, format = "yyyy/MM/dd hh:mm:ss", empty = "--") {
  if (timestamp == 0 || !timestamp) {
    return empty;
  }
  return new Date(timestamp * 1000).format(format);
}

//时间转换
function tsToTime(timestamp, hasSecond = true) {
  let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let format = "yyyy/MM/dd hh:mm";
  if (hasSecond) {
    format += ":ss";
  }
  return date.format(format);
}
function formatSeconds(seconds, options) {
  let defaultOptions = { hourText: "时", minuteText: "分", secondText: "秒" };
  options = Object.assign({}, defaultOptions, options);
  let content = "";
  if (seconds > 3600) {
    content += parseInt(seconds / 3600) + options.hourText;
  }
  if (seconds > 60) {
    content += parseInt((seconds / 60) % 60) + options.minuteText;
  }
  if (seconds % 60 > 0 || !content) {
    content += (seconds % 60) + options.secondText;
  }
  return content;
}
function calcPrice(price) {
  if (!price) price = 0;
  return (price / 100).toFixed(2);
}
function getWeek(timeStamp) {
  let date = new Date(timeStamp * 1000);
  let day = date.getDay();
  if (day == 0) {
    return "周日";
  } else if (day == 1) {
    return "周一";
  } else if (day == 2) {
    return "周二";
  } else if (day == 3) {
    return "周三";
  } else if (day == 4) {
    return "周四";
  } else if (day == 5) {
    return "周五";
  } else if (day == 6) {
    return "周六";
  }
  return "";
}

// 获取中文数字
function toChinesNum(num) {
  let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  let getWan = temp => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    for (let i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0
          ? ""
          : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
          ? ""
          : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
        newNum;
    }
    return newNum;
  };
  let overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) {
    noWan = "0" + noWan;
  }
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}
function downloadBase64(base64, fileName) {
  let arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let blob = new Blob([u8arr], {
    type: mime,
  });
  let blobUrl = URL.createObjectURL(blob);
  let link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  link.click();
}
// 时间长度 4 天
function timeMeter(t, type = 1, pre = true) {
  let time = Number(t);
  let day = "00";
  if (type == 4) {
    day =
      time / (3600 * 24) < 10 && pre
        ? "0" + parseInt(time / (3600 * 24))
        : parseInt(time / (3600 * 24));
  }
  if (day != "00" || (pre && day != "0")) time = time - day * (3600 * 24);
  let h =
    time / 3600 < 10 && pre
      ? "0" + parseInt(time / 3600)
      : parseInt(time / 3600);
  if (h != "00" || (pre && h != "0")) time = time - h * 3600;
  let m =
    time / 60 < 10 && pre ? "0" + parseInt(time / 60) : parseInt(time / 60);
  let s = time % 60 < 10 && pre ? "0" + (time % 60) : time % 60;
  return timeType(type, day, h, m, s);
}
function timeType(type, day, h, m, s) {
  if (type == 1) {
    return h + ":" + m + ":" + s;
  } else if (type == 2) {
    return m + "分" + s + "秒";
  } else if (type == 3) {
    return h + "时" + m + "分" + s + "秒";
  } else if (type == 4) {
    return (day || 0) + "天 " + h + "小时 " + m + "分钟" + s + "秒";
  }
}
// 2019-6-24
function timestampToDay(timestamp) {
  let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D =
    date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
  return Y + M + D;
}

/**
 * 时间戳 => 10-10
 * */
function timestampToMD(timestamp) {
  let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + ".";
  let D =
    (date.getDate() + 1 < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  return M + D;
}

/**
 * 时间戳 => 10:10
 * */

function timestampToHM(timestamp) {
  let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let h =
    (date.getHours() + 1 < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    date.getMinutes() + 1 < 10 ? "0" + date.getMinutes() : date.getMinutes();
  // var s = (date.getSeconds() + 1 < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return h + m;
  // return Y + M + D;
}

/**
 * 时间戳 =>判断时间戳区间（ 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年 ）
 * */
function timeJudge(time_start, time_end) {
  let time_s = new Date(time_start * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let time_e = new Date(time_end * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let today = new Date(); //当前时间
  let Y_s = time_s.getFullYear() + ".";
  let Y_e = time_e.getFullYear() + ".";
  let Y_n = today.getFullYear() + ".";
  let M_s =
    (time_s.getMonth() + 1 < 10
      ? "0" + (time_s.getMonth() + 1)
      : time_s.getMonth() + 1) + ".";
  let M_e =
    (time_e.getMonth() + 1 < 10
      ? "0" + (time_e.getMonth() + 1)
      : time_e.getMonth() + 1) + ".";
  let D_s =
    (time_s.getDate() + 1 < 10 ? "0" + time_s.getDate() : time_s.getDate()) +
    " ";
  let D_e =
    (time_e.getDate() + 1 < 10 ? "0" + time_e.getDate() : time_e.getDate()) +
    " ";
  //判断
  if (Y_s == Y_e) {
    //同年
    if (Y_s == Y_n) {
      //今年
      if (M_s == M_e && D_s == D_e) {
        //今年不跨日
        return 0;
      } else {
        //今年跨日
        return 1;
      }
    } else if (M_s == M_e && D_s == D_e) {
      //往年不跨日
      return 2;
    } else {
      //往年跨日
      return 3;
    }
  } else {
    //跨年
    return 4;
  }
}

/*
 * 中国标准时间Wed Oct 24 2018 20:00:00 GMT+0800 (中国标准时间) 转YY-MM-DD HH:MM:SS
 * */
function timestampToTime(timestamp) {
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = date.getDate() + " ";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
}

// 获取时间跨度
function getDuration(start_date, end_date) {
  let dateStr;
  // 0:今年不跨日 / 1:今年跨日 / 2:往年不跨日 / 3:往年跨日 / 4：跨年
  const type = timeJudge(start_date, end_date);
  switch (type) {
    case 0:
      dateStr =
        timestampToMD(start_date) +
        timestampToHM(start_date) +
        " - " +
        timestampToHM(end_date);
      break;
    case 1:
      dateStr =
        timestampToMD(start_date) +
        timestampToHM(start_date) +
        " - " +
        timestampToMD(end_date) +
        timestampToHM(end_date);
      break;
    case 2:
      dateStr =
        timestampToDay(start_date) +
        timestampToHM(start_date) +
        " - " +
        timestampToHM(end_date);
      break;
    case 3:
      dateStr =
        timestampToDay(start_date) +
        timestampToHM(start_date) +
        " - " +
        timestampToMD(end_date) +
        timestampToHM(end_date);
      break;
    case 4:
      dateStr =
        timestampToDay(start_date) +
        timestampToHM(start_date) +
        " - " +
        timestampToDay(end_date) +
        timestampToHM(end_date);
      break;
    default:
      dateStr = "不支持的时间格式";
      break;
  }
  return dateStr;
}

// 防抖
function debounce(func, wait) {
  let timer;
  return function () {
    let context = this;
    let args = arguments;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

// 节流
function throttle(func, wait) {
  let timer;
  return function () {
    let context = this;
    let args = arguments;
    if (timer) return;
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, wait);
  };
}

// 获取字母序号 number >= 1
function getLetterNumber(number) {
  return String.fromCharCode(64 + number);
}
function getDpi() {
  let div = document.createElement("div");
  div.style.width = "10pt";
  div.style.position = "absolute";
  div.style.zIndex = "-1";
  document.body.appendChild(div);
  let width = div.clientWidth;
  document.body.removeChild(div);
  return (10 * 72) / width;
}
function handleMathJax(parent) {
  let promises = [];
  parent = parent || document;
  parent.querySelectorAll("mjx-container,svg").forEach(mjx => {
    let promise = new Promise(resolve => {
      let svg;
      if (mjx.tagName == "svg") {
        svg = mjx;
      } else {
        svg = mjx.querySelector("svg");
      }
      let serializer = new XMLSerializer();
      let img = document.createElement("img");
      img.src =
        "data:image/svg+xml;base64," +
        btoa(unescape(encodeURIComponent(serializer.serializeToString(svg))));
      img.style.width = svg.getAttribute("width");
      img.style.height = svg.getAttribute("height");
      img.style.position = "absolute";
      img.style.zIndex = "-1";
      img.onload = function () {
        document.body.appendChild(img);
        let imgNew = document.createElement("img");
        let canvas = document.createElement("canvas");
        canvas.setAttribute("width", img.naturalWidth);
        canvas.setAttribute("height", img.naturalHeight);
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        imgNew.src = canvas.toDataURL("image/png");
        imgNew.width = img.width;
        imgNew.height = img.height;
        mjx.parentNode.replaceChild(imgNew, mjx);
        document.body.removeChild(img);
        resolve();
      };
    });
    promises.push(promise);
  });
  return Promise.all(promises);
}
function toFixed(num, s) {
  let times = Math.pow(10, s);
  let des = num * times + 0.5;
  des = parseInt(des, 10) / times;
  return des + "";
}

// 数组元素交换
function swapArrayItem(arr, fromIndex, toIndex) {
  arr[toIndex] = arr.splice(fromIndex, 1, arr[toIndex])[0];
  return arr;
}

// 提取数组指定key，并拼接成字符串
function joinArray(arr, key, split = ",") {
  const retAry = [];
  arr &&
    arr.length &&
    arr.forEach(i => {
      retAry.push(i[key]);
    });
  return retAry.join(split);
}

// 获取当前时间戳，单位秒
function getCurTimestamp() {
  return parseInt(new Date().getTime() / 1000);
}

// 将对象第一级属性全部重置为空字符串
// obj - 待处理对象     exceptKeyAry - 排除的键值数组    val - 重置的值
function clearObj(obj, exceptKeyAry = [], val = "") {
  for (const key in obj) {
    if (exceptKeyAry.includes(key)) continue;
    obj[key] = val;
  }
}

// 停止body滚动
function stopBodyScroll(isStop) {
  let ele = document.documentElement;
  if (isStop) {
    ele.style["overflow-y"] = "hidden";
  } else {
    ele.style["overflow-y"] = "scroll";
  }
}

function appendJs(js) {
  if (!js) {
    return;
  }
  if (js.indexOf("</script>") > 0) {
    window.$(document.body).append(window.$(js));
  } else {
    let dom = document.createElement("script");
    dom.type = "text/javascript";
    dom.text = js;
    document.body.appendChild(dom);
  }
}
//等保,type==1说明需要验证,val是要验证的值,返回true验证通过，否则给出提示语
function guarantee(type, val) {
  let regTest = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%*#?&~^()-+=<>]{6,16}$/;
  let msg = "密码必须包含数字和大小写字母任意两种组合，长度6-16位";
  if (type == 1) {
    if (!regTest.test(val)) {
      return msg;
    } else {
      return true;
    }
  } else {
    return true;
  }
}
function isText(_value) {
  //字符串是空就输出空，防止undefined
  _value = "" + _value;
  if (
    _value == "null" ||
    _value == null ||
    _value == "" ||
    _value == "undefined"
  ) {
    return "";
  }
  return _value;
}
// 带提示表格头的渲染器
function gridHeadRender(label, content, sortable = false) {
  return h => {
    let sortableElement = h(
      "span",
      {
        class: "caret-wrapper",
      },
      [
        h("i", {
          class: "sort-caret ascending",
        }),
        h("i", {
          class: "sort-caret descending",
        }),
      ],
    );
    return h("section", [
      h("span", {}, label),
      sortable ? sortableElement : "",
      h(
        "el-popover",
        {
          props: {
            trigger: "hover",
            content,
            width: 250,
            "popper-class": "table-header-popover",
          },
        },
        [
          h("i", {
            class: "el-icon-question",
            style: "color: #FCB723;font-size: 16px;",
            slot: "reference",
          }),
        ],
      ),
    ]);
  };
}

function getScreenHeight() {
  let div = document.createElement("div");
  div.style.position = "fixed";
  div.style.top = "0";
  div.style.right = "0";
  div.style.bottom = "0";
  div.style.left = "0";
  div.style.zIndex = "-1";
  document.body.appendChild(div);
  let height = div.clientHeight;
  document.body.removeChild(div);
  return height;
}

function download(url) {
  return new Promise(resolve => {
    let xhr = new XMLHttpRequest();
    xhr.open("get", url + "?" + new Date().getTime());
    xhr.responseType = "blob";
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        let blob = xhr.response;
        let blobUrl = URL.createObjectURL(blob);
        resolve(blobUrl);
      }
    };
    xhr.send();
  });
}

function downloadFile(url, fileName, callback) {
  if (url.indexOf("?") < 0) {
    url += "?";
  } else {
    url += "&";
  }
  let xhr = new XMLHttpRequest();
  xhr.open("get", url + new Date().getTime());
  xhr.responseType = "blob";
  xhr.onreadystatechange = () => {
    if (xhr.readyState == 4 && xhr.status == 200) {
      let blob = xhr.response;
      let blobUrl = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      link.click();

      callback && callback();
    }
  };
  xhr.onerror = () => {
    callback && callback();
  };
  xhr.send();
}

/**
 * base64转file
 * @param {*} dataurl base64串
 */
function dataURLtoFile(dataurl) {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

/**
 * 获取 uuid
 * @param {*} len 生成uuid的长度
 */
function uuid(len = 16) {
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
    "",
  );
  let uuids = [],
    i,
    radix = chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuids[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;
    // rfc4122 requires these characters
    uuids[8] = uuids[13] = uuids[18] = uuids[23] = "-";
    uuids[14] = "4";
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuids[i]) {
        r = 0 | (Math.random() * 16);
        uuids[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuids.join("");
}

function getTitle(webTitle, route) {
  if (!route.meta) {
    return webTitle;
  }
  let subTitle;
  if (route.meta.title) {
    subTitle = route.meta.title;
  } else if (route.meta.bread && route.meta.bread.length > 0) {
    subTitle = route.meta.bread[route.meta.bread.length - 1].title;
  }
  if (!subTitle) {
    return webTitle;
  }
  subTitle = typeof subTitle === "function" ? subTitle(route) : subTitle;
  if (!subTitle) {
    return webTitle;
  }
  return subTitle + "-" + webTitle;
}

function handleNewLine(content) {
  if (!content) {
    return content;
  }
  return content.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
}
function splitStr(arr, attr, cut = ",") {
  let str = "";
  arr &&
    arr.length &&
    arr.forEach(item => {
      str += item[attr] + cut;
    });
  str = str.substr(0, str.length - 1);
  return str;
}

// 拼装课次作业的所属课次信息
function generateArrangeBelong(vueObj, classify, grade, subject, time) {
  const belongs = [];
  const getters = vueObj.$store.getters;
  if (getters.getSwitch("classify")) {
    belongs.push(classify);
  }
  if (getters.getSwitch("grade")) {
    belongs.push(grade);
  }
  if (subject) {
    belongs.push(subject);
  }
  if (time) {
    belongs.push(time);
  }
  return belongs.join(" ");
}
function format(date, f) {
  let o = {
    "M+": date.getMonth() + 1, // month
    "d+": date.getDate(), // day
    "h+": date.getHours(), // hour
    "m+": date.getMinutes(), // minute
    "s+": date.getSeconds(), // second
    "q+": Math.floor((date.getMonth() + 3) / 3), // quarter
    S: date.getMilliseconds(), // millisecond
  };
  if (/(y+)/.test(f))
    f = f.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length),
    );
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(f))
      f = f.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k]
          : ("00" + o[k]).substr(("" + o[k]).length),
      );
  }
  return f;
}
function getFileType(file_name) {
  let type = "";
  if (
    /\.(wma|mp4|aac|flac|m4a|oga|opus|3gp|mpg|mpeg|3g2|avi|flv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(
      file_name,
    )
  ) {
    type = "video";
  } else if (/\.(doc|docx)$/i.test(file_name)) {
    type = "word";
  } else if (/\.(xls|xlsx)$/i.test(file_name)) {
    type = "excel";
  } else if (/\.(pdf)$/i.test(file_name)) {
    type = "pdf";
  } else if (/\.(ppt|pptx)$/i.test(file_name)) {
    type = "ppt";
  } else if (/\.(zip)$/i.test(file_name)) {
    type = "zip";
  } else if (/\.(mp3|wav|wmv)$/i.test(file_name)) {
    type = "audio";
  } else if (/\.(txt)$/i.test(file_name)) {
    type = "txt";
  } else if (/\.(png|jpg|jpeg|gif|webp)$/i.test(file_name)) {
    type = "image";
  } else {
    type = "file";
  }
  return type;
}
export default {
  format,
  getTime,
  ts,
  tsFormat,
  calcPrice,
  tsToTime,
  formatSeconds,
  getWeek,
  uuid,
  timestampToDay,
  timestampToMD,
  timestampToHM,
  timeJudge,
  getDuration,
  debounce,
  throttle,
  getLetterNumber,
  getDpi,
  handleMathJax,
  toFixed,
  swapArrayItem,
  joinArray,
  getCurTimestamp,
  dataURLtoFile,
  clearObj,
  stopBodyScroll,
  appendJs,
  guarantee,
  isText,
  gridHeadRender,
  downloadBase64,
  timeMeter,
  getScreenHeight,
  download,
  downloadFile,
  getTitle,
  handleNewLine,
  splitStr,
  toChinesNum,
  timestampToTime,
  generateArrangeBelong,
  getFileType,
};
